


































import app from "@/app";
import BaseComponent from "@/components/BaseComponent.vue";
import { Component } from "vue-property-decorator";
import { SXSector } from "../gobl.bundle";

@Component
export default class WSectorsList extends BaseComponent {
	loading = false;

	get sectors() {
		return app.services.sectors.list();
	}
	get isAdmin() {
		return app.services.users.isAdmin();
	}
	getCustomData(sector: SXSector, key: string) {
		let data = this.ux_custom_data(sector.data);
		return data[key];
	}
	created() {
		if (!this.sectors.length) {
			let ctx = this,
				always = () => (ctx.loading = false);
			ctx.loading = true;
			app.services.sectors.loadSectors(always, false);
		}
	}
}
